import React from 'react';
import { useTranslation } from 'react-i18next';
import { Clock } from 'lucide-react';

import { formatClock } from '../../utils/plannerDates';
import { ComboField, type ComboOption } from './ComboField';
import { parseTime } from './parseFields';

export const TIME_OPTIONS: ComboOption[] = Array.from({ length: 72 }, (_, index) => ({ value: 6 * 60 + index * 15 }));

interface TimeFieldProps {
  value: number | null;
  onChange: (minute: number | null) => void;
  label: string;
  options?: ComboOption[];
  clearable?: boolean;
  placeholder?: string;
  width?: number;
  listWidth?: number;
}

export const TimeField: React.FC<TimeFieldProps> = ({
  value,
  onChange,
  label,
  options = TIME_OPTIONS,
  clearable = false,
  placeholder,
  width = 120,
  listWidth,
}) => {
  const { t, i18n } = useTranslation('planner');
  return (
    <ComboField
      value={value}
      onChange={onChange}
      display={(minute) => formatClock(minute, i18n.language)}
      parse={parseTime}
      options={options}
      label={label}
      placeholder={placeholder ?? t('fields.time')}
      clearable={clearable}
      icon={<Clock className="h-4 w-4 shrink-0 text-theme-text-tertiary" aria-hidden="true" />}
      ltr
      width={width}
      listWidth={listWidth}
    />
  );
};
